const calcrem = (size) => `${size / 16}rem`;

export default calcrem;
